<ng-template #content let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-8 offset-md-2 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                                Contacto
                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">

            <div class="row">
                <div class=" col-12 col-md-8 offset-md-2">

                    <app-search-client (close)="closeAddClient()"></app-search-client>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- ══════════════════════════════════════════════════════════════════════════
     CONTACTOS — ESTATUS. La lista con los tres estados del cliente.

     🔴 REDISEÑO 2026-09-21, el mismo molde que `contacts`. Juan, mirando esa
     pantalla: *«mira cómo se ven esas listas gigantes. Dios mío»*.

     Ésta era peor que su gemela: la tarjeta traía además tres insignias de
     estado apiladas debajo del nombre, así que cada persona ocupaba ~165 px.
     Y las insignias son lo que se viene a comparar entre personas — apiladas
     dentro de una tarjeta no se comparan, se leen una por una.

     Como tabla, los tres estados son TRES COLUMNAS: se recorren de arriba
     abajo y se ve de un golpe quién está trabado en cuál.

     🔴 NO SE TOCÓ EL COMPONENTE: `getPeople`, `nextRows`, `onScrollDown`,
     `toogleStatusClient`, `executeReview` y `debugAndOpenModal` son los mismos.
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="kb-page">

  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title flex items-center gap-2">
        <i class="fas fa-user-check text-[0.85em] text-muted-foreground" aria-hidden="true"></i>Contactos — estatus
      </h1>
      <p class="kb-page-meta">
        En qué punto está cada cliente: su biometría, su onboarding y si quedó aprobado.
      </p>
    </div>
  </div>

  <!-- ══ Filtros ══════════════════════════════════════════════════════════════ -->
  <section class="kb-tarjeta">
    <div class="flex flex-col gap-4 px-6 sm:flex-row sm:flex-wrap sm:items-end">
      <div class="space-y-1.5">
        <label class="kb-campo-et" for="fEstatus">Estatus</label>
        <div class="kb-select-envoltorio w-full sm:w-44">
          <select id="fEstatus" class="kb-select" [(ngModel)]="approveStatus" (change)="getPeople(true)">
            <option value="ALL">Todos</option>
            <option value="REFUSED">Rechazado</option>
            <option value="APPROVED">Aprobado</option>
          </select>
          <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
        </div>
      </div>

      <div class="space-y-1.5">
        <label class="kb-campo-et" for="fBiometria">Biometría</label>
        <div class="kb-select-envoltorio w-full sm:w-44">
          <select id="fBiometria" class="kb-select" [(ngModel)]="biometricStatus" (change)="getPeople(true)">
            <option value="ALL">Todos</option>
            <option value="Accepted">Aprobado</option>
            <option value="Pending">Pendiente</option>
            <option value="Declined">Rechazado</option>
          </select>
          <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
        </div>
      </div>

      <div class="space-y-1.5">
        <!-- 🔴 «Onbordig» estaba mal escrito en la pantalla. -->
        <label class="kb-campo-et" for="fOnboarding">Onboarding</label>
        <div class="kb-select-envoltorio w-full sm:w-44">
          <select id="fOnboarding" class="kb-select" [(ngModel)]="onboardingStatus" (change)="getPeople(true)">
            <option value="ALL">Todos</option>
            <option value="COMPLETE">Completado</option>
            <option value="IN_PROGRES">Pendiente</option>
          </select>
          <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
        </div>
      </div>

      <div class="space-y-1.5">
        <span class="kb-campo-et block">En revisión</span>
        <div class="flex min-h-[2.5rem] items-center">
          <ng-toggle (change)="toogleStatusClient()" [(ngModel)]="usQuoteClien" [value]="true"
                     [color]="{ checked: '#01abce', unchecked: '#dcdcdc' }"></ng-toggle>
        </div>
      </div>
    </div>
  </section>

  <!-- ══ Los resultados ═══════════════════════════════════════════════════════ -->
  <section class="kb-tarjeta" *ngIf="people">
    <div class="kb-tarjeta-cab">
      <div class="space-y-1">
        <h2 class="text-base font-semibold leading-none">
          <span class="tabular-nums">{{ rows.length }}</span>
          de <span class="tabular-nums">{{ people_total | number }}</span>
          {{ people_total === 1 ? 'persona' : 'personas' }}
        </h2>
        <p class="text-sm text-muted-foreground">
          Al llegar al final se cargan más solas.
        </p>
      </div>
      <div class="kb-tarjeta-accion flex items-center gap-2" *ngIf="usQuoteClien">
        <span class="text-xs text-muted-foreground">{{ reloadStadisticLoading ? 'Actualizando…' : 'Últ. actualización' }}</span>
        <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" title="Volver a revisar"
                aria-label="Volver a revisar" *ngIf="!reloadStadisticLoading" (click)="executeReview()">
          <i class="fas fa-sync-alt" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="kb-tarjeta-cuerpo">
      <div class="kb-tabla-plana" infiniteScroll
           [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="2"
           [infiniteScrollThrottle]="50"
           (scrolled)="onScrollDown()" (scrolledUp)="onScrollUp()">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Persona</th>
              <th class="kb-th">Cédula</th>
              <th class="kb-th">Contacto</th>
              <th class="kb-th">Biometría</th>
              <th class="kb-th">Onboarding</th>
              <th class="kb-th">Estatus</th>
              <th class="kb-th">Se registró</th>
              <th class="kb-th kb-th-acciones">Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr class="kb-tr last:border-b-0" *ngFor="let item of rows; let i = index">

              <td class="kb-td">
                <div class="flex items-center gap-3">
                  <span class="ct-avatar" [class.ct-avatar-activo]="usersActives[item?.params?.code]"
                        [style.background-image]="'url(' + (item?.params?.selfie || 'assets/public/images/avatar.png') + ')'"
                        aria-hidden="true"></span>
                  <span class="kb-td-titulo capitalize">
                    {{ item?.params?.name }} {{ item?.params?.lastName }}
                  </span>
                </div>
                <p class="kb-td-sub" *ngIf="item?.person?.ejecutive">
                  Ejecutivo: {{ item?.person?.ejecutive?.name }} {{ item?.person?.ejecutive?.lastName }}
                </p>
              </td>

              <td class="kb-td kb-td-mono">{{ item?.params?.code_identity }}{{ item?.params?.identity }}</td>

              <td class="kb-td">
                <div class="text-sm">{{ item?.params?.phone || '—' }}</div>
                <p class="kb-td-sub">{{ item?.params?.email || 'Sin correo' }}</p>
              </td>

              <td class="kb-td">
                <span class="kb-badge kb-badge-contorno" *ngIf="item?.params?.person_biometric_status">
                  {{ item?.params?.person_biometric_status }}
                </span>
                <span class="text-muted-foreground" *ngIf="!item?.params?.person_biometric_status">—</span>
              </td>

              <td class="kb-td">
                <span class="kb-badge kb-badge-contorno" *ngIf="item?.params?.onboarding_status">
                  {{ item?.params?.onboarding_status }}
                </span>
                <p class="kb-td-sub" *ngIf="item?.params?.onboarding_sections_complete">
                  {{ item?.params?.onboarding_sections_complete }}
                </p>
                <span class="text-muted-foreground" *ngIf="!item?.params?.onboarding_status">—</span>
              </td>

              <td class="kb-td">
                <span class="kb-badge kb-badge-contorno" *ngIf="item?.params?.approve_status">
                  {{ item?.params?.approve_status }}
                </span>
                <!-- «En revisión» va junto al estatus, que es lo que la revisión decide. -->
                <p class="kb-td-sub kb-texto-alerta" *ngIf="item?.params?.review">En revisión</p>
                <span class="text-muted-foreground" *ngIf="!item?.params?.approve_status && !item?.params?.review">—</span>
              </td>

              <!-- 🔴 SIN LA HORA. La hora exacta de un registro no se usa para
                   comparar personas, y sus 80 px empujaban el botón de Revisión
                   —que es lo que se viene a hacer acá— fuera de la pantalla. -->
              <td class="kb-td whitespace-nowrap">{{ item?.params?.date | date: 'dd/MM/yyyy' }}</td>

              <td class="kb-td-acciones">
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm"
                        [disabled]="!item?.params?.code"
                        [title]="item?.params?.code ? 'Abrir la revisión' : 'Esta persona no tiene código: no se puede revisar'"
                        (click)="debugAndOpenModal(item)">
                  <i class="fas fa-external-link-alt" aria-hidden="true"></i>Revisión
                </button>
              </td>
            </tr>

            <tr *ngIf="!loading && rows.length < 1">
              <td colspan="8">
                <div class="kb-empty">
                  <span class="kb-empty-icono"><i class="fas fa-user-check" aria-hidden="true"></i></span>
                  <p class="kb-empty-titulo">No se encontró ninguna persona</p>
                  <p class="kb-empty-texto">Ajusta los filtros de arriba para ver más resultados.</p>
                </div>
              </td>
            </tr>

            <tr *ngIf="loading">
              <td colspan="8">
                <div class="space-y-3 py-2">
                  <div class="kb-skeleton h-4 w-full" *ngFor="let s of [1,2,3,4,5]"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-center pt-1" *ngIf="!loading && rows.length > 0">
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="nextRows()">
          <i class="fas fa-chevron-down" aria-hidden="true"></i>Cargar más contactos
        </button>
      </div>
    </div>
  </section>
</div>
